import { Helmet } from 'react-helmet';
import logo from '../logo.svg';
import '../styles/Newsroom.css';
import NavBar from "./NavBar";
import Footer from "./Footer";
import MnM from '../img/MnM.svg'
import PalmRay from '../ray-dark.png'
import Button from './reusables/Button';
// import { useState, useEffect } from 'react';





function Newsroom() {

    // const [email, setEmail] = useState("");
    // const [notification, setNotification] = useState("");
    // const [isSuccess, setIsSuccess] = useState(false);

    const handleGoBack = () => {
        window.location.href = "/"
    }

    // const handleSubmit = async () => {
    //      // Simple email validation regex
    //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    //     // Check if the email is valid
    //     if (!emailRegex.test(email)) {
    //         setNotification("Please enter a valid email address.");
    //         setIsSuccess(false);
    //         return; // Stop further execution if the email is invalid
    //     }

    //     try {
    //         console.log("Email being sent:", email);
    //         const response = await fetch("http://localhost:9000/api/emails", {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({ email: email })
    //         }
    //         );

    //         if (response.ok) {
    //             setNotification("We've received your email! Our team will reach out with your report.")
    //             setIsSuccess(true)
    //         }
    //         else {
    //             const errorData = await response.json(); // Parse the JSON response
    //             setNotification(errorData.message); // Set the error message from the backend
    //             setIsSuccess(false)
    //         }
    //     }

    //     catch (error) {
    //         setNotification("Error on our side, thanks for waiting!")
    //         setIsSuccess(false)
    //     }
    // }

    // const handleEmailChange = (e) => {
    //     setEmail(e.target.value);
    // };

    //  // Effect to clear notification after 5 seconds
    //  useEffect(() => {
    //     if (notification) {
    //         const timer = setTimeout(() => {
    //             setNotification('');
    //         }, 5000); // Clear notification after 2.5 seconds

    //         return () => clearTimeout(timer); // Cleanup on unmount or when notification changes
    //     }
    // }, [notification]);



    const openURL = () => {
        window.open("https://ray.palmdigitalz.online", "_target");
    }

    const links = [
        { url: "#ranking", target: "_self", displayText: "Ranking" },
        { url: "#reports", target: "_self", displayText: "Reports" },
        { url: "#news", target: "_self", displayText: "News" },
        { url: "#socials", target: "_self", displayText: "Socials" },
    ];

    return (
        <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Newsroom - PalmDigitalz</title>
            <link rel="canonical" href="http://palmdigitalz.com/newsroom" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="description" content="The Newsroom of PalmDigitalz" />
            <meta name="keywords" content="PalmDigitalz News, palmdigitalz, app modernization news, legacy modernization news" />
        <link rel="icon" href={logo}></link>
        </Helmet>

        <div className="welcomeNewsroom">
                {/* <h1 id="gradientTextHome">Think. Do you really need to modernize?</h1> */}
                {/* <h1 id="gradientTextHome">Save Million $'s with ₹1<sup>*</sup></h1> */}
                <div id="promoSectionOne" className="promoSectionOne">
                    <img src={PalmRay} alt="Markets and Markets™ Logo" height="300rem" width="300rem"></img>
                </div>
                
                <div className="promoSectionTwo">
                    <h1 id="promotional">A <span id="modernizeHighlight">Ray of light</span> in PHP modernization.</h1>
                    <h2>Try now. <span id="offerHighlight">for free.</span></h2>
                </div>
                <div className="promoSectionThree">
                    {/* <input
                        type="email"
                        placeholder="your business e-mail"
                        value={email}
                        onChange={handleEmailChange}
                     />
                    <br></br> */}
                    <Button 
                    button={{
                        class:"sendEmailButton",
                        onClick:openURL,
                        displayText:"Modernize my PHP"
                    }}
                    /> 
                </div>
                <br></br>
            </div>
            {/* {notification && (
                <div
                    className={`notification ${isSuccess ? 'success' : 'error'}`}
                >
                    {notification}
                </div>
            )} */}

        <NavBar 
            className="navigationBar"
            links={links}
            showBackIcon={true}
            goBackTo={handleGoBack}
        />

        <div className="newsroomWrapper">
            <div className="newsroomWelcomeWords">
                <h1 id="promoMainHeading">News <span id="cominIn">Room</span></h1>
                {/* <h2>We have a <span id="leapHeading">Palm All™</span>.</h2> */}
                {/* <img src={palmAll} alt="Palm All™ Logo"></img> */}
                
            </div>

            <section id="ranking">
                <div className="newsroomHeading">
                    <h1>In Industry.</h1>
                </div>
                <div className="companyRanking">
                        <div className="rankingBox">
                            <h2>#5</h2>
                            <h4>Pervasive Player</h4>
                        </div>

                        <div className="rankingBox">
                            <h2>#14</h2>
                            <h4>in the World.</h4>
                        </div>
        
                </div>
            </section>

            <section id="reports">
                <div className="newsroomHeading">
                    <h1>Reports.</h1>
                </div>
                <div className="companyReports">
                        <div className="reportBox">
                            <img src={MnM} alt="Markets and Markets™ Logo"></img>
                            {/* <h2>#5</h2> */}
                            <h4>Market Report</h4>
                        </div>

                        <div className="reportBox">
                            <img height={250} src={logo} alt="PalmDigitalz™ Logo"></img>
                            {/* <h2>#14</h2> */}
                            <h4>Company Portfolio</h4>
                        </div>
        
                </div>
            </section>

            <section id="news">
                <div className="newsroomHeading">
                    <h1>In the News.</h1>
                </div>
                <div className="newsPage">
                    <div className="newsArticle head">
                        <i class="fa-solid fa-newspaper"></i>
                    </div>
                </div>
                <div className="newsPage">
                <div className="article">
                        <h2>
                        <a 
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.cbs42.com/business/press-releases/ein-presswire/817921341/palmdigitalz-launches-beta-version-of-palm-ark-transforming-php-applications-into-business-rules-and-python-code/">
                            PHP application to Business Rules + Python
                            </a>
                        </h2>           
                        <br></br>
                        <h4>PRESS RELEASE</h4>
                        <h5>Worldwide | June 2, 2025</h5> 
                    </div>
                    <div className="article">
                        <h2>
                        <a 
                            target="_blank"
                            rel="noreferrer"
                            href="https://fox40.com/business/press-releases/ein-presswire/787818108/palmdigitalz-recognized-as-a-key-player-in-application-modernization/">
                            Recognized as a Key Player in Application Modernization
                            </a>
                        </h2>           
                        <br></br>
                        <h4>PRESS RELEASE</h4>
                        <h5>Sacramento, USA | February 21, 2025</h5> 
                    </div>
                </div>
                <div className="newsPage">
                    <div className="article">
                        <h2>
                        <a 
                            target="_blank"
                            rel="noreferrer"
                            href="https://cioinfluence.com/digital-transformation/palmdigitalz-launches-palm-360-redefining-it-modernization-and-cost-efficiency-for-the-future/">
                            PalmDigitalz launches Palm 360™
                            </a>
                        </h2>           
                        <br></br>
                        <h4>PRESS RELEASE</h4>
                        <h5>Worldwide | January 6, 2025</h5> 
                    </div>
                    <div className="article">
                        <h2>
                        <a 
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.business-standard.com/content/press-releases-ani/palmdigitalz-expands-chennai-operations-to-drive-global-leadership-in-mainframe-application-modernization-124111901225_1.html">
                            PalmDigitalz expands Chennai operations
                            </a>
                        </h2> 
                        <br></br>
                        <h4>PRESS RELEASE</h4>
                        <h5>Chennai, TN | November 19, 2024</h5>                                  
                    </div>
                </div>
                <div className="newsPage">
                    <div className="newsArticle head">
                        <i class="fa-solid fa-newspaper"></i>
                    </div>
                </div>
            </section>

            <section id="socials">
                <div className="newsroomHeading">
                    <h1>Socials.</h1>
                </div>
                <div className="socialLinks">

                    <div className="socialBox">
                        <a rel="noreferrer" target="_blank" href="https://in.linkedin.com/company/palmdigitalz">
                            <i className="fa-brands fa-linkedin"></i>
                        </a>                       
                    </div>

                    <div className="socialBox">
                        <a rel="noreferrer" target="_blank" href="https://www.instagram.com/palmdigitalz/">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                    </div>

                    <div className="socialBox">
                        <a rel="noreferrer" target="_blank" href="https://www.youtube.com/@palmdigitalz5969">
                            <i className="fa-brands fa-youtube"></i>
                        </a>
                    </div>

                    <div className="socialBox">
                        <a rel="noreferrer" target="_blank" href="https://www.facebook.com/palmdigitalz/">
                            <i className="fa-brands fa-facebook"></i>
                        </a>
                    </div>

                    <div className="socialBox">
                        <a rel="noreferrer" target="_blank" href="https://www.x.com/PalmDigitalz/">
                            <i className="fa-brands fa-x-twitter"></i>
                        </a>
                    </div>
        
                </div>
            </section>
        </div>

        <Footer />
        </>
    );
}

export default Newsroom